<template>
  <v-container>
    <v-text-field
      prepend-inner-icon="search"
      v-model="search"
      class="ma-1"
      label="Search..."
      outline
      color="secondary"
    />

    <v-layout row wrap justify-center :style="{height: '600px', overflowY: 'scroll'}">
      <v-flex v-for="item in allPickingsModel" :key="item.id" sm5 xs12 class="ma-1">
        <v-card color="primary" class="elevation-5 main-cards" @click="handleCardSelect(item)">
          <v-card-title class="pb-0">
            <h2 class="card-title-name">{{item.partner_id[1] || ""}}</h2>
            <v-spacer />
            <h2>{{item.x_total_initial_quant || ""}}</h2>
          </v-card-title>
          <v-card-text>
            <h4>{{localizeDate(item.scheduled_date.replace(" ", 'T'), true) || ""}}</h4>
            <h4>{{ item.street ? item.street : ''}}</h4>
          </v-card-text>
          <v-card-text :style="{textAlign: 'left', position: 'absolute', bottom: 0}">
            <h2>{{item.origin || ""}}</h2>
          </v-card-text>
          <v-card-text :style="{textAlign: 'right', position: 'absolute', bottom: 0}">
            <h2>{{item.name || ""}}</h2>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <SignIn v-model="signInView" :item="selectedItem" />
  </v-container>
</template>


<script>
import { mapGetters } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";
import SignIn from "@/components/wholesaleNY/SignIn";
import Common from "@/mixins/Common";
import Axios from "axios";
import CONSTANTS from "@/constants";

export default {
  name: "wholesaleNY",

  data() {
    return {
      search: "",
      allPickingsModel: [],
      signInView: false,
      selectedItem: []
    };
  },

  mixins: [Common, LoginCheck],

  components: {
    SignIn
  },

  computed: {
    ...mapGetters({
      allPickings: "picking/getPickings",
      token: "app/getToken"
    }),
    totalItems() {
      return this.allPickings.length;
    }
  },

  watch: {
    search(val) {
      if (val === "") this.allPickingsModel = this.allPickings;
      else
        this.allPickingsModel = this.allPickings.filter(picking => {
          let partner = picking.partner_id[1] || "";
          let name = picking.name || "";
          let origin = picking.origin || "";
          if (
            partner.toLowerCase().includes(val.toLowerCase()) ||
            name.toLowerCase().includes(val.toLowerCase()) ||
            origin.toLowerCase().includes(val.toLowerCase())
          )
            return picking;
        });
    },
    allPickings: {
      handler(val) {
        if (val) {
          let count = 0;
          val.forEach(async item => {
            item.street = await this.getPartners(item);
            count++;
            if (count === val.length) this.allPickingsModel = val;
          });
        }
      },
      deep: true
    },
    signInView(val) {
      if (!val) this.selectedItem = [];
    }
  },

  mounted() {
    this.getOrders();
  },

  methods: {
    getOrders() {
      this.$store.dispatch("picking/search", [
        {
          field: "picking_type_id",
          operator: "in",
          value: [23, 12]
        },
        {
          field: "state",
          operator: "=",
          value: "assigned"
        }
      ]);
    },
    handleCardSelect(item) {
      this.signInView = true;
      this.selectedItem = item;
    },
    async getPartners(item) {
      const { data } = await Axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.token}`
        },
        url: `${CONSTANTS.API_BASE_URL}/odoo/search/res.partner/1`,
        data: {
          conditions: [
            {
              field: "id",
              operator: "=",
              value: item.partner_id[0]
            }
          ]
        }
      });

      return data.bindle[0].street;
    }
  }
};
</script>

<style scoped>
.main-cards {
  min-height: 15em;
  max-height: 15em;
}
.main-cards:hover {
  cursor: pointer;
}
.card-title-name {
  width: 65%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>